import { render, staticRenderFns } from "./ColleagueAccess.vue?vue&type=template&id=2f29823e&scoped=true"
import script from "./ColleagueAccess.vue?vue&type=script&lang=js"
export * from "./ColleagueAccess.vue?vue&type=script&lang=js"
import style0 from "./ColleagueAccess.vue?vue&type=style&index=0&id=2f29823e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f29823e",
  null
  
)

export default component.exports